import { useTranslation } from "react-i18next";
import useBreakpoint from "../hooks/useBreakpoint";
import { mobilePagination, themeBasedPagination } from "./customStyles";

export default function Pagination({ totalPages = 0, activePageNumber = 1, onChange, theme }) {
  const screenSize = useBreakpoint();

  const total = Number(totalPages) || 0;
  const current = Number(activePageNumber) || 1;
  const { t } = useTranslation();
  const windowSize = 3;

  if (total < 2) return null;

  const getPageWindow = () => {
    if (total <= windowSize) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }
    let start = current - Math.floor(windowSize / 2);
    start = Math.max(1, start);
    start = Math.min(start, total - windowSize + 1);
    return Array.from({ length: windowSize }, (_, i) => start + i);
  };
  const pageWindow = getPageWindow();

  // helpers to detect gaps
  const windowStart = pageWindow[0];
  const windowEnd = pageWindow[pageWindow.length - 1];

  return (
    <nav
      className={`${screenSize === "sm" ? "start-50 translate-middle-x" : ""}`}
      aria-label='Page Navigation'
      style={{ position: "absolute", bottom: screenSize === "sm" ? 22 : 18, right: screenSize === "sm" ? "" : 18 }}
    >
      <ul
        className='pagination justify-content-center justify-content-sm-end m-0'
        style={
          screenSize === "sm"
            ? {
                ...themeBasedPagination(theme),
                ...mobilePagination,
              }
            : {
                ...themeBasedPagination(theme),
              }
        }
      >
        {/* Prev */}
        <li className={`page-item${current === 1 ? " disabled" : ""}`}>
          <button className='page-link' onClick={() => current > 1 && onChange(current - 1)} disabled={current === 1}>
            {t("requests.nav.prev")}
          </button>
        </li>

        {/* — show “1” if we’re not already starting there — */}
        {windowStart > 1 && (
          <li className='page-item'>
            <button className='page-link' onClick={() => onChange(1)}>
              1
            </button>
          </li>
        )}

        {/* — only show an ellipsis if the gap is > 1 page — */}
        {windowStart > 2 && (
          <li className='page-item disabled'>
            <span className='page-link'>…</span>
          </li>
        )}

        {/* — the 4-page window — */}
        {pageWindow.map((page) => (
          <li key={page} className={`page-item${page === current ? " active" : ""}`}>
            <button className='page-link' onClick={() => onChange(page)}>
              {page}
            </button>
          </li>
        ))}

        {/* — only show an ellipsis if there’s a gap > 1 before last — */}
        {windowEnd < total - 1 && (
          <li className='page-item disabled'>
            <span className='page-link'>…</span>
          </li>
        )}

        {/* — show “totalPages” button if we’re not ending there — */}
        {windowEnd < total && (
          <li className='page-item'>
            <button className='page-link' onClick={() => onChange(total)}>
              {total}
            </button>
          </li>
        )}

        {/* Next */}
        <li className={`page-item${current === total ? " disabled" : ""}`}>
          <button className='page-link' onClick={() => current < total && onChange(current + 1)} disabled={current === total}>
            {t("requests.nav.next")}
          </button>
        </li>
      </ul>
    </nav>
  );
}
